import { render, staticRenderFns } from "./HandleAssignTemplateSidebar.vue?vue&type=template&id=9efe464a&scoped=true&"
import script from "./HandleAssignTemplateSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleAssignTemplateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleAssignTemplateSidebar.vue?vue&type=style&index=0&id=9efe464a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efe464a",
  null
  
)

export default component.exports